/**
 * @ai Department Domain — Query Key Constants
 * @business Centralised React Query key factory for all department cache entries.
 *   Using a factory keeps invalidation precise — invalidating `departmentKeys.all`
 *   busts every department cache (lists + details) after a mutation.
 * @related lib/domains/departments/hooks.ts — consumes these keys
 * @related https://tkdodo.eu/blog/effective-react-query-keys — key factory pattern
 */

export const departmentKeys = {
  /** Root key — invalidate to bust all department caches */
  all: ["departments"] as const,

  /** All list variants (e.g., filtered lists) */
  lists: () => [...departmentKeys.all, "list"] as const,

  /** All detail variants */
  details: () => [...departmentKeys.all, "detail"] as const,

  /** Single department detail by ID */
  detail: (id: string) => [...departmentKeys.details(), id] as const,
}
